var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Turkey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#ff3d00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.789,23.188l-0.008-2.73l1.609,2.199l2.594-0.848l-1.598,2.211L26,26.223l-2.598-0.836 l-1.594,2.215l-0.012-2.73l-2.598-0.832L21.789,23.188z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.473,31.086c-3.898,0-7.063-3.16-7.063-7.059s3.16-7.059,7.063-7.059 c0.633,0,1.242,0.09,1.828,0.246c-1.219-0.75-2.648-1.191-4.184-1.191c-4.418,0-8,3.582-8,8s3.582,8,8,8 c1.535,0,2.965-0.438,4.184-1.188C19.715,30.996,19.105,31.086,18.473,31.086z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Turkey);
export default __webpack_public_path__ + "static/media/icons8-turkey.85053788b76c43ecfcfefa70929c8e3f.svg";
export { ForwardRef as ReactComponent };